import { useMemo } from "react";
import { Operation, FormOtp } from "../types";

export interface UseSlideFormValueArgs {
    isLastStep: boolean;
    formErrors: unknown;
    formErrorsResolved: unknown;
    operation: Operation | null | undefined;
    formSubmitted: boolean;
    goToThankYouPage: boolean | undefined;
    goToListPage: boolean | undefined;
    otp: FormOtp;
    currentStep: number;
}

/**
 * Computes the horizontal translate percentage applied to the form slider.
 *
 * Each "extra" step (errors / buyers list / otp / thankyou) shifts the slider
 * by an additional -100/-200/-300/-400 on top of the base step offset.
 */
export function useSlideFormValue({
    isLastStep,
    formErrors,
    operation,
    formSubmitted,
    goToThankYouPage,
    goToListPage,
    otp,
    currentStep,
    formErrorsResolved,
}: UseSlideFormValueArgs): number {
    return useMemo(() => {
        // form errors step
        if (
            isLastStep &&
            formErrors
            // ||
            // (formErrorsResolved && !otp?.isRequired && !otp?.isResolved)
        ) {
            return currentStep * -100 - 100;
        }

        // buyers list step
        if (
            operation?.key === "ROUND_TWO" &&
            (!formSubmitted || (formSubmitted && goToThankYouPage))
        ) {
            return currentStep * -100 - 300;
        }

        // otp step
        if (
            otp?.isRequired ||
            (otp?.isResolved &&
                goToThankYouPage &&
                operation?.key !== "ROUND_TWO")
        ) {
            return currentStep * -100 - 200;
        }

        // thankyou step
        if (formSubmitted && !goToThankYouPage && !goToListPage) {
            return currentStep * -100 - 400;
        }

        // form steps (default)
        return currentStep * -100;
    }, [
        formSubmitted,
        goToThankYouPage,
        isLastStep,
        otp,
        currentStep,
        formErrorsResolved,
        formErrors,
        operation?.key,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ]);
}
